import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class CaixaService {

  getCaixa(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/caixa/visualiza/' + itemId, { observe: 'response' })
  }

  getCaixas(): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/caixa/visualizatodas/', { observe: 'response' })
  }

  postCaixa(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/caixa/inclui/', item, { observe: 'response' })
  };

  putCaixa(item: any, itemId: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/caixa/atualiza/' + itemId, item, { observe: 'response' })
  };

  deleteCaixa(itemId: any): Observable<HttpResponse<any>> {
    return this.http.delete(
      environment.webApiSaguiControlUrl + '/api/caixa/exclui/' + itemId, { observe: 'response' })
  }

  getEmpresas(): Observable<HttpResponse<any>> {

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/empresa/visualizatodas', { observe: 'response' })
  }

  getCaixasEmpresa(itemId: any): Observable<HttpResponse<any>> {

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/caixa/visualizacaixasempresa/' + itemId, { observe: 'response' })
  }


  getContaCorrentes(): Observable<HttpResponse<any>> {

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrente/visualizatodas', { observe: 'response' })
  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
